import React, { useEffect, useState } from "react";
import "./My_Orders.css";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { Button } from "react-bootstrap";
// import OrderCard from '../common_components/order_card/OrderCard';
import { useNavigate } from "react-router-dom";
import OrderCard from "./order_card/OrderCard";
import {
  orderGet,
  returnOrderGet,
} from "../../../../../utils/apis/myAccount/myAccount";
import { formatCustomDate, IDS } from "../../../../../utils/common";
// import Common_Back_Header from '../common_components/common_back_header/Common_Back_Header';

const My_Orders = () => {
  const navigate = useNavigate();

  const [order, setOrder] = useState([]);
  const fetchOrder = async () => {
    const res = await orderGet([IDS?.order_status?.Ordered,IDS?.order_status?.Processing,IDS?.order_status?.Shipped]);
    if (res?.success) {
      setOrder(res.data);
    }
  };
  useEffect(() => {
    fetchOrder();
  }, []);

  const [orderDeliver, setOrderDeliver] = useState([]);
  const fetchOrderDeliver = async () => {
    const res = await orderGet(IDS?.order_status?.Deliverd);
    if (res?.success) {
      setOrderDeliver(res.data);
    }
  };
  useEffect(() => {
    fetchOrderDeliver();
  }, []);

  const [orderCancel, setOrderCancel] = useState([]);
  const fetchOrderCancel = async () => {
    const res = await orderGet(IDS?.order_status?.Cancelled);
    if (res?.success) {
      setOrderCancel(res.data);
    }
  };
  useEffect(() => {
    fetchOrderCancel();
  }, []);

  const [orderReturn, setOrderReturn] = useState([]);
  const fetchOrderReturn = async () => {
    const res = await returnOrderGet(IDS?.order_status?.Cancelled);
    if (res?.success) {
      setOrderReturn(res.data);
    }
  };
  useEffect(() => {
    fetchOrderReturn();
  }, []);

  return (
    <section className="My_Orders">
      <div className="container">
        {/* <Common_Back_Header backNavigation="/my-profile" /> */}

        <div className="action_tab_section">
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <Nav variant="pills" className="">
                  <Nav.Item>
                    <Nav.Link eventKey="first">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Image/my_order/in_img1.png"
                          }
                        />
                      </div>

                      <span className="tab_text">Ordered</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="second">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Image/my_order/in_img2.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Delivered</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="third">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Image/my_order/in_img3.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Cancelled</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="fourth">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/Image/my_order/in_img3.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Returned</span>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>

              <div className="col-lg-9 col-md-8">
                <div className="">
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <div className="">
                        {order?.map((val) => (
                          <OrderCard
                            order={val}
                            navigate={`/order-details/${val?.id}`}
                            title={val?.product?.name}
                            showtracking
                            footer_text_color="#0F3768"
                            img="/assets/images/profile/myaccount/img1.png"
                            orderId={val?.invoice_number}
                            items={val?.quantity}
                            kwd={val?.total_amount}
                            // footer_text="Delivering in 10 mins"
                            date={formatCustomDate(val?.updatedAt)}
                          />
                        ))}
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="second">
                      <div className="">
                        {orderDeliver?.map((val) => (
                          <OrderCard
                           order={val}
                            navigate={`/order-details/${val?.id}`}
                            title={val?.product?.name}
                            showtracking
                            footer_text_color="#0F3768"
                            img="/assets/images/profile/myaccount/img1.png"
                            orderId={val?.invoice_number}
                            items={val?.quantity }
                            kwd={val?.total_amount}
                            // footer_text="Delivering in 10 mins"
                            date={formatCustomDate(val?.updatedAt)}
                          />
                        ))}
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="third">
                      <div className="">
                        {orderCancel?.map((val) => (
                          <OrderCard
                           order={val}
                            navigate={`/order-details/${val?.id}`}
                            title={val?.product?.name}
                            // showtracking
                            footer_text_color="#0F3768"
                            img="/assets/images/profile/myaccount/img1.png"
                            orderId={val?.invoice_number}
                            items={val?.quantity }
                            kwd={val?.total_amount}
                            // footer_text="Delivering in 10 mins"
                            date={formatCustomDate(val?.updatedAt)}
                          />
                        ))}
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="fourth">
                      <div className="">
                        {orderReturn?.map((val) => (
                          <OrderCard
                           order={val}
                            navigate={`/order-details/${val?.id}`}
                            title={val?.product?.name}
                            showtracking
                            footer_text_color="#0F3768"
                            img="/assets/images/profile/myaccount/img1.png"
                            orderId={val?.invoice_number}
                            items={val?.quantity }
                            kwd={val?.total_amount}
                            // footer_text="Delivering in 10 mins"
                            date={formatCustomDate(val?.updatedAt)}
                          />
                        ))}
                      </div>
                    </Tab.Pane>
                  </Tab.Content>

                  <div className="no_more_main_order_div ">
                    <div className="no_more_order_div">
                      <p>No more orders to show</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Tab.Container>
        </div>
      </div>
    </section>
  );
};

export default My_Orders;
